import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { FileText, Calculator, Map, ArrowRight } from 'lucide-react';

export const BlogSidebar: React.FC = () => {
  return (
    <div className="space-y-8">
      {/* Tool CTA: Fine Calculator */}
      <Card className="bg-red-50 dark:bg-red-900/10 border-red-100 dark:border-red-900/30">
        <CardHeader className="pb-2">
          <div className="w-10 h-10 bg-red-100 text-red-600 rounded-lg flex items-center justify-center mb-2">
            <Calculator size={20} />
          </div>
          <CardTitle className="text-lg">EPA Fine Risk Calculator</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground mb-4">
            Missed inspections can cost $64k/day. Calculate your project's potential exposure.
          </p>
          <Button variant="outline" className="w-full border-red-200 text-red-700 hover:bg-red-100" asChild>
            <Link to="/tools/fine-calculator">Calculate Risk</Link>
          </Button>
        </CardContent>
      </Card>

      {/* Resource CTA: Templates */}
      <Card className="bg-blue-50 dark:bg-blue-900/10 border-blue-100 dark:border-blue-900/30">
        <CardHeader className="pb-2">
          <div className="w-10 h-10 bg-blue-100 text-blue-600 rounded-lg flex items-center justify-center mb-2">
            <FileText size={20} />
          </div>
          <CardTitle className="text-lg">Free SWPPP Templates</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground mb-4">
            Download editable PDF & Word inspection logs, corrective action forms, and more.
          </p>
          <Button variant="outline" className="w-full border-blue-200 text-blue-700 hover:bg-blue-100" asChild>
            <Link to="/resources/templates">Get Templates</Link>
          </Button>
        </CardContent>
      </Card>

      {/* Directory Links */}
      <Card>
        <CardHeader className="pb-2">
          <div className="flex items-center gap-2">
            <Map size={18} className="text-muted-foreground" />
            <CardTitle className="text-base">State Regulations</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="space-y-1">
          <Link to="/swppp-requirements/texas" className="block text-sm text-muted-foreground hover:text-primary py-1 border-b border-border/50">Texas (TCEQ) Guide</Link>
          <Link to="/swppp-requirements/california" className="block text-sm text-muted-foreground hover:text-primary py-1 border-b border-border/50">California (CGP) Guide</Link>
          <Link to="/swppp-requirements/florida" className="block text-sm text-muted-foreground hover:text-primary py-1 border-b border-border/50">Florida (FDEP) Guide</Link>
          <Link to="/swppp-requirements" className="block text-sm font-medium text-primary pt-2 flex items-center gap-1 hover:underline">
            View All States <ArrowRight size={12} />
          </Link>
        </CardContent>
      </Card>
    </div>
  );
};
